import { Heading } from "@chakra-ui/react";
import { SituationTable } from "../../components/SituationContent/SituationTable";

export function SituationListPage() {
  return <>
    <Heading as="h1" mb="4">Situaties</Heading>
    <SituationTable />
  </>
}
